import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { ensureTenantEstateQueryData } from '@/features/tenants/api/tenant-estates';
import { TenantSection } from '@/pages/tenant-section';
import { SORT_BY_DIRECTION, SORT_BY_VALUES } from '@/utils/sortTypes';

export const Route = createFileRoute('/_authenticated/_sidebar-layout/tenant/$tenantId/estates')({
  validateSearch: zodValidator(
    z.object({
      search: fallback(z.string().optional(), ''),
      enableFilters: fallback(z.boolean().optional(), false),
      view: fallback(z.enum(['grid', 'list', 'map']).optional(), 'list'),
      filters: z.record(z.unknown()).optional(),
      sort: fallback(
        z
          .object({
            by: z.enum(SORT_BY_VALUES),
            order: z.enum(SORT_BY_DIRECTION),
          })
          .optional(),
        undefined
      ),
    })
  ),
  component: TenantEstateComponent,
  loader: ensureTenantEstateQueryData,
});

function TenantEstateComponent() {
  const { tenantId } = Route.useParams();

  return <TenantSection active="estates" id={tenantId} />;
}
